import React from "react";

export default function AddonCard({
  addon,
  qty,
  inCart,
  onChangeQty,
  onAddPlan,
}) {
  return (
    <div className={`addon-card${inCart ? " in-cart" : ""}`}>
      <div className={`addon-bar ${addon.barClass}`} />

      <div className="addon-body">
        <div className="addon-emo">{addon.emoji}</div>
        {(() => {
          const [prefix, ...rest] = addon.title.split(": ");
          return (
            <>
              <div className="addon-title-prefix">{prefix}:</div>
              <div className="addon-title">{rest.join(": ")}</div>
            </>
          );
        })()}
        <div className="addon-base-pill">{addon.basePill}</div>
        <div className="addon-desc">{addon.desc}</div>

        <div className="addon-extras">
          {addon.extras.map((e, i) => (
            <div className={`ae ${e.cls}`} key={i}>
              <span className="ae-ico">{e.ico}</span>
              {e.text}
            </div>
          ))}
        </div>

        <div className="addon-price-row">
          <div className="addon-amount">
            ₹{addon.price.toLocaleString("en-IN")}
          </div>
          <div className="addon-per">/member/year</div>
        </div>
      </div>

      <div className="addon-foot">
        <div className="qty-wrap">
          <button className="qb" onClick={() => onChangeQty(addon.id, -1)}>
            −
          </button>
          <div className="qv">{qty}</div>
          <button className="qb" onClick={() => onChangeQty(addon.id, 1)}>
            +
          </button>
        </div>
        <button
          className={`add-btn${inCart ? " active" : ""}`}
          onClick={() => {
            const [prefix, ...rest] = addon.title.split(": ");
            onAddPlan(addon.id, prefix + ":", addon.price, addon.mrp, addon.sku, rest.join(": "));
          }}
        >
          {inCart ? "Added ✓" : "Add"}
        </button>
      </div>
    </div>
  );
}
